export const UNFREEZE_TIME_MINUTES = 2;
export const TEST_PHONE_NUMBER = '4150000000';
